import { ProductReducer } from './product.reducer';

export const reducers = ProductReducer;
